import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addannounce from "./components/addannounce";
export default {
  name: "announceList",
  mixins: [loadMoreList, serchSelect],
  components: {
    addannounce: addannounce
  },
  data: function data() {
    return {
      pagingReqFn: "Announce",
      pagingReqValue: "data",
      paramsData: {
        id: '',
        language: '',
        title: '',
        type_id: '',
        content: '',
        author: '',
        top: '',
        state: '',
        game_type: ''
      },
      announceTypeList: [],
      drawer: false,
      content: '',
      delIds: [],
      state: [{
        label: '启用',
        value: 1
      }, {
        label: '禁用',
        value: 0
      }],
      top: [{
        label: '置顶',
        value: 1
      }, {
        label: '不置顶',
        value: 0
      }],
      tableBody: 'announceListTable',
      sortReq: 'announceChangeSort'
    };
  },
  activated: function activated() {
    var _this = this;

    this.getList();
    this.$api.announceTypeList().then(function (res) {
      if (res.code == 0) {
        _this.announceTypeList = res.data;
      }
    });
  },
  watch: {
    deep: true
  },
  methods: {
    viewCheck: function viewCheck(row) {
      this.drawer = true;
      this.content = this.$utils.textRepl(row.content);
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delAnnounce',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this2.getList();
      });
    }
  }
};